import React from "react"
import Header from "../header/Header"
import Footer from "../footer/Footer"
import { useStaticQuery, graphql } from "gatsby"

const query = graphql`
  {
    allStrapiLogin {
      nodes {
        signin
        title_registration
      }
    }
  }
`

const Layout = props => {
  const data = useStaticQuery(query)
  const signin = data.allStrapiLogin.nodes[0].signin
  const registration = data.allStrapiLogin.nodes[0].title_registration

  return (
    <>
      <Header
        pageMode={props.pageMode}
        signin={signin}
        registration={registration}
      />

      {props.children}
      <Footer />
    </>
  )
}

export default Layout
